import { Injectable } from '@angular/core';
import { Society } from '../interfaces/society';
import { RestApiService } from './rest-api.service';

@Injectable({
  providedIn: 'root'
})
export class SocietiesService {

  public societies: Array<Society> = [];
  public count: number = 0;
  public maxPages: number = 1;
  public pageSize: number = 24;
  public code: string = "";

  constructor(
    private api: RestApiService
  ) { }

  getSociety(id): Promise<any> {
    return new Promise((resolve, reject) => {
      this.api.get('/MI_Galago/WCF_MI_Galago/REST/vop/society/' + id, {}, true).then((res) => {
        console.log("societer", res)
        resolve(res);
      });
    });
  }

  updateSocietyCount(search?: string): Promise<any> {
    return new Promise((resolve, reject) => {
      let query: any = {};

      if (typeof search === 'string' && search.length > 0) {
        query.search = search;
      }
      this.api.get('/MI_Galago/WCF_MI_Galago/REST/GetSocietiesVopCount', query, true).then((res) => {
        this.count = res;
        this.maxPages = Math.ceil(res / this.pageSize);
        if (res <= this.pageSize) {
          this.maxPages = 0;
        }
        resolve(res);
      });
    });
  }

  getSocietyCount(): number {
    return this.count;
  }

  getSocietyMaxPages(): number {
    return this.maxPages;
  }

  getSocieties(): Promise<any> {
    return new Promise((resolve, reject) => {
      this.api.get('/MI_Galago/WCF_MI_Galago/REST/GetSocietiesVop', {}, false).then((res) => {
        if (typeof res === 'object' && res.length > 0) {
          this.societies = res;
        }
        resolve(res);
      });
    });
  };

  getSocietyInvoices(idSociety, page): Promise<any> {
    return new Promise((resolve, reject) => {
      this.api.get('/MI_Galago/WCF_MI_Galago/REST/vop/society/' + idSociety + '/booking-invoice', {
        page: page,
        pageSize: 4
      }, true).then((res) => {
        resolve(res);
      });
    });
  }

  updateSociety(society): Promise<any> {
    return new Promise((resolve, reject) => {
      this.api.put(`/MI_Galago/WCF_MI_Galago/REST/vop/society`, {
        society: society
      }, false).then((res) => {
        resolve(res);
      });
    });
  }

  updateSocieties(page, search?: string): Promise<any> {
    return new Promise((resolve, reject) => {
      let query: any = {
        page: page,
        pageSize: this.pageSize,
        column: 4,
        sortType: 1
      }

      if (typeof search === 'string' && search.length > 0) {
        query.search = search;
      }

      this.api.get('/MI_Galago/WCF_MI_Galago/REST/GetSocietiesVop', query, true).then((res) => {
        if (typeof res === 'object' && res.length > 0) {
          this.code = res[0].Code
          this.societies = res;
        }
        resolve(res);
      });
    });
  }

  addSociety(society: {
    Address: string,
    Name: string,
    Mobile: string,
    Code: string,
    ManagerLastName: string,
    ManagerFirstName: string,
    ManagerMobile: string,
    ManagerEMailAddress: string,
    AdminLastName: string,
    AdminFirstName: string,
    AdminMobile: string,
    AdminEMailAddress: string
  }): Promise<any> {
    return new Promise((resolve, reject) => {
      this.api.post('/MI_Galago/WCF_MI_Galago/REST/vop/society', {
        society: society
      }, false).then((res) => {
        resolve(res);
      });
    });
  }

  getStaffMembers(idSociety): Promise<any> {
    return new Promise((resolve, reject) => {
      this.api.get(`/MI_Galago/WCF_MI_Galago/REST/vop/society/${idSociety}/staff-members`, {}, false).then((res) => {
        resolve(res);
      })
    });
  }

  updateStaffMembers(idSociety, members): Promise<any> {
    return new Promise((resolve, reject) => {
      this.api.post(`/MI_Galago/WCF_MI_Galago/REST/vop/society/${idSociety}/staff-members`, {
        members: members
      }, false).then((res) => {
        resolve(res);
      })
    });
  }

}
